/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import '../styles/marcaciones.css';

// Components
// Material Mui
import { Grid, 
  TextField, 
  Tooltip,
  Button, 
  Autocomplete, 
  useMediaQuery,
  Card,
  CardContent,  
  Typography,
  CircularProgress 
} from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
import { makeStyles } from '@mui/styles';

// Customs
import Item from '../components/custom/Item';
import Heading from '../components/heading/Heading';
import Formatter from '../scripts/formatters';
import CustomNoRowsOlverlay from '../components/custom/CustomNoRowsOlverlay';
import msgNotificacion from '../scripts/notification';
import CustomToolBar from '../components/custom/CustomToolbar';

// Iconos
import RestartAltIcon from '@mui/icons-material/RestartAlt';

// Redux
import { useDispatch } from 'react-redux';
import { showProgress } from '../redux/reducers/progress.Slice';
import { PAGE_SIZE, NAME_PROJECT, ROLES_PERMITIDOS } from '../redux/constants/index';

// Services
import EmpleadoService from '../services/empleadoService';

// Estilos personalizados DataGrid
const useStyles = makeStyles({
  customValue: {
    color: 'red',
    backgroundColor: 'lavenderblush', // Para celdas
  },
  customCell: {
    color: 'red',
    backgroundColor: 'lightblue', // Estilos personalizados para las celdas
  },
  customCellIn: {
    color: '#212529',
    backgroundColor: 'limegreen' // Para celdas con status Entrada
  },
  customCellOut: {
    color: '#fff',
    backgroundColor: '#f27474', // Para celdas con status Salida
  },
  customCellBreak: {
    color: 'red',
    backgroundColor: 'lightyellow', // Para celdas con status ALMUERZO
  },
});

export default function Marcaciones() {
  const userLogin = JSON.parse(localStorage.getItem('user'))
  const dispatch = useDispatch()
  const isMobile = useMediaQuery('(max-width: 740px)')

  // States
  const [loading, setLoading] = useState(false)
  const [dataMarcaciones, setDataMarcaciones] = useState([])
  const [dataEmpleadosCbo, setDataEmpleadosCbo] = useState([])
  const [empleadoSelected, setEmpleadoSelected] = useState(null)
  const [filteredData, setFilteredData] = useState([])  
  const [valueFechas, setValueFechas] = useState({
    fechaIni: '',
    fechaFin: '',
  })

  const columns = [
    { 
      field: 'Consecutivo',
      headerName: 'Consecutivo',
      width: 100,
      align: 'center',
      headerAlign: 'center',
      resizable: false
    },
    { 
      field: 'CodigoEmpleado',
      headerName: 'No. Empleado',
      width: 120,
      align: 'center',
      headerAlign: 'center',
      resizable: false
    },
    { 
      field: 'Nombre',
      headerName: 'Nombre del Empleado',
      minWidth: 200,
      align: 'left',
      headerAlign: 'left',
      flex: 1,
    },
    { 
      field: 'Cargo',
      headerName: 'Cargo',
      minWidth: 200,
      align: 'left',
      headerAlign: 'left',
      flex: 1,
    },  
    { 
      field: 'FechaHora',
      headerName: 'Fecha marcación',
      width: 150,
      align: 'center',
      headerAlign: 'center',
      valueFormatter: ( value ) => Formatter.dateTimeFormatter(value),
    },
    { 
      field: 'StatusText',
      headerName: 'Estatus',
      width: 180,
      align: 'center',
      headerAlign: 'center',      
    }, 
  ]

  const classes = useStyles();

  const getCellClassName = (params) => {
    // Condición para aplicar la clase CSS al valor específico de la celda
    if (params.field === 'StatusText' && params?.value === 'ENTRADA') {
      return classes.customCellIn;
    } 

    if (params.field === 'StatusText' && params?.value === 'SALIDA') {
      return classes.customCellOut;
    }

    if (params.field === 'StatusText' && params?.value && params.value.slice(0,8) === 'ALMUERZO') {
      return classes.customCellBreak;
    }

    return '';
  };

  // Arrow functions.
  const handleChangeFechas = (event) => {
    try {
      setValueFechas({
        ...valueFechas,
        [event.target.name]: event.target.value
      })
    } catch (error) {
      console.error(error)
    }
  }

  // Get Vacaciones.
  const getMarcaciones = async (data) => {
    try {      
      setLoading(true)

      EmpleadoService.getMarcaciones(data)
      .then((response) => {
          if (!response) {
            msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
            setLoading(false)
            return
          }          
  
          setTimeout(() => {
            if (response.Codigo === 1) {
              const dataResponse = response?.Data              
              
              setDataMarcaciones(dataResponse)
              
              if (!valueFechas.fechaIni || !valueFechas.fechaFin) {
                setFilteredData(dataResponse)
              } else {
                filtrarMarcaciones(valueFechas.fechaIni, valueFechas.fechaFin)
              }
            } else {
              setDataMarcaciones([])
              setFilteredData([])
              msgNotificacion(response.Mensaje, 'info')
            }
            setLoading(false)
          }, 500);
      })
      .catch((error) => {
        dispatch(showProgress(false));
        msgNotificacion(error, 'error')
      })
    } catch (error) {
      console.error(error)
    }
  }

  const filtrarMarcaciones = (fecha1, fecha2) => {
    try {      
      const fechaIni = new Date(fecha1)
      const fechaFin = new Date(fecha2)
      
      const filteredData = dataMarcaciones.filter((item) => {
        const itemDate = formatearFecha(item.FechaHora)
        const fecha = new Date(itemDate)
        
        return fecha >= fechaIni && fecha <= fechaFin
      })
        
      setFilteredData(filteredData)    
    } catch (error) {
      console.error(error)
    }
  }

  const formatearFecha = (date) => {
    if (!date) {
      return
    }
  
    let dateAsString = date.toString().substring(0, 10)
    let dateParts = dateAsString.split("-")
    let day = dateParts[2]
    let month = dateParts[1]
    let year = dateParts[0]
  
    return `${year}-${month}-${day}`;
  }

  const refreshMarcaciones = () => {
    try {
      const dataRequest = {
        codEmpleado: !empleadoSelected ? userLogin.CodigoEmpleado : empleadoSelected.id
      }

      //console.log(dataRequest)
      getMarcaciones(dataRequest)
    } catch (error) {
      console.error(error)
    }
  }

  const getDatosEmpleadosCbo = async () => {
    try {
      const data = {
        codEmpleado: userLogin.CodigoEmpleado
      }
      
      EmpleadoService.getEmpleadosMarcaciones(data)
        .then((response) => {
          if (!response) {
            msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
            return
          }
  
          if (response.Codigo === 1) {
            const dataEmpleados = response?.Data || []

            setDataEmpleadosCbo(dataEmpleados)
          } else {
            setDataEmpleadosCbo([])
            msgNotificacion(response.Mensaje, 'warning')
          }
        })
        .catch((error) => {
          msgNotificacion(error, 'error')
          dispatch(showProgress(false))
        })
    } catch (error) {
      console.error(error)
    }
  }

  const handleChangeEmpleado = (event, values) => {
    try {
      setEmpleadoSelected(values)
      
      //console.log(values)
      if (!values) {
        setLoading(true)
        
        setTimeout(() => {
          setFilteredData([])
          setLoading(false)
        }, 500);

        return
      }

      setLoading(true)
      
      const codEmpleado = values.id
      const data = {
        codEmpleado: codEmpleado
      }

      setTimeout(() => {
        getMarcaciones(data)
        setLoading(false)
      }, 500);

    } catch (error) {
      console.error(error)
    }    
  }

  //
  let initPage = false;

  useEffect(() => {
    document.title = `Registro de Marcaciones - ${NAME_PROJECT}`

    try {
      dispatch(showProgress(true))

      setTimeout(() => {
        if (!initPage) {
          initPage = true

          const data = {
            codEmpleado: userLogin.CodigoEmpleado
          }

          getMarcaciones(data)

          getDatosEmpleadosCbo()
        }

        dispatch(showProgress(false))
      }, 1000)
    } catch (error) {
      console.error(error)
    }
  }, [])

  return <div className='App-content'>
  <Heading className='mt-0 w-100 heading heading-title'>
    <div className='heading-text w-100 heading-text-marcaciones'>
      <i className='bx bx-history me-2'></i>
      <span>Historial de Marcaciones</span>
    </div>

      <Autocomplete
        id="cboEmpleados"
        getOptionLabel={option => (option.id + ' - ' + option.label)}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        options={dataEmpleadosCbo}
        fullWidth
        className='me-2 text-transform-none'
        value={empleadoSelected || null}
        onChange={handleChangeEmpleado}
        renderInput={(params) => <TextField {...params} label="Listado de Empleados" className='text-transform-none' />}
      />
    
    <div className='d-flex dv-filt-fechas-marc'>
      <Tooltip title='Refrescar datos'>
        <Button
          variant='outlined'
          className='text-transform-none me-2 btn-refresh-marc'
          color='info'
          startIcon={<RestartAltIcon />}
          onClick={() => refreshMarcaciones()}
          size='small'
        >
          Refrescar
        </Button>
      </Tooltip>

      <div className='d-flex'>
        <TextField
            id='txtFechaInicio'
            name='fechaIni'
            type='date'
            label='Fecha inicial'
            size='small'
            value={valueFechas.fechaIni}
            onChange={handleChangeFechas}
            className='ms-auto mx-1 filt-fechas-marc'
            InputLabelProps={{
              shrink: true,
              className: 'LabelMui'
            }}
          />

          <TextField
            id='txtFechaFinal'
            name='fechaFin'
            type='date'
            label='Fecha final'
            size='small'
            value={valueFechas.fechaFin}
            onChange={handleChangeFechas}
            className='mx-1 filt-fechas-marc'
            InputLabelProps={{
              shrink: true,
              className: 'LabelMui'
            }}
          />
      </div>
    </div>
  </Heading>

    <>
      {isMobile ? (
        // Vista móvil: Lista de tarjetas
        loading ?
        <Grid container spacing={1} paddingX={1} height='100%' textAlign='center' alignItems='center'>
          <Grid item xs={12}>
            <CircularProgress color='inherit' />
          </Grid>
        </Grid>
        :
        <Grid container spacing={1} paddingX={1} paddingTop={1}>
          {filteredData.map((row) => (
            <Grid item xs={12} key={row.Consecutivo}>
              <Card>
                <CardContent>
                  <Typography variant="h6"><strong>Registro #{row.Consecutivo}</strong></Typography>
                  <Typography variant="body2">
                    <strong>Empleado: </strong><span className='mx-1'>{row.CodigoEmpleado} - {row.Nombre.toUpperCase()}</span>
                  </Typography>
                  <Typography variant="body2">
                    <strong>Fecha marcación:</strong><span className='mx-1 text-danger fw-bolder'>{Formatter.dateTimeFormatter(row.FechaHora)}</span>
                  </Typography>  
                  <Typography
                    variant="body2"
                    className={
                      row?.StatusText === 'ENTRADA' ? classes.customCellIn : 
                      (row?.StatusText && row.StatusText.slice(0,8) === 'ALMUERZO') ? classes.customCellBreak :
                      row?.StatusText === 'SALIDA' ? classes.customCellOut :
                      null
                    }
                    display='flex'
                    alignItems='center'
                    borderRadius={4}
                    paddingLeft={0.5}
                  >
                  <strong>Estatus:</strong><span className='mx-1'>{row.StatusText}</span>
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Grid container spacing={1}>
          <Grid item xs={12} md={12} marginX={1}>
            <Item className='MuiPaper-root-dataGrid-marcaciones'>
              <DataGrid
                rows={filteredData}
                columns={columns.map((column) => ({
                  ...column,
                  //headerClassName: column.field === 'CodigoEmpleado' ? classes.customColumn : '', // Agregar la clase CSS al titulo
                  cellClassName: getCellClassName, // Utilizar la función getCellClassName para aplicar la clase CSS
                }))}
                getRowId={(row) => row?.Consecutivo}
                pageSize={PAGE_SIZE}
                pageSizeOptions={[5, 10, 25, 50, 100]}
                loading={loading}
                localeText={Formatter.localizedTextsMapColumns}
                // Ocultar la casilla de check all.
                sx={{
                  "& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer": {
                    display: "none"
                  }
                }}
                showCellVerticalBorder
                showColumnVerticalBorder
                //density='compact'
                slots={{
                  noRowsOverlay: CustomNoRowsOlverlay,
                  toolbar: CustomToolBar,
                }}
              />
            </Item>
          </Grid>
        </Grid>
      )
      }
    </>
</div>
}